import { useQuery } from "@tanstack/react-query"
import { API } from "config"

const useSuppliers = () => useQuery({
    queryKey: ['suppliers'],
    queryFn: async () => {
        const res = await API.get('/store/suppliers')
        // Laravel ResourceCollection envolve em { data: [...] }; retorna o array diretamente
        return res?.data?.data ?? res?.data
    },
    staleTime: 1000 * 60 * 30,
})

export default useSuppliers
